// extracted by mini-css-extract-plugin
export var callCard = "_p7-0";
export var callMessageButton = "_p7-1";
export var helpIcon = "_p7-3";
export var helpIconContainer = "_p7-4";
export var verticalDivider = "_p7-2";